import { ModeloIndicador } from "./modelo-indicador"

export class IndicadorAlerta  {
    public deferimentoAtivo?: boolean
    public inicioAmareloDeferimento?: number
    public finalAmareloDeferimento?: number

    public indeferimentoAtivo?: boolean
    public inicioAmareloIndeferimento?: number
    public finalAmareloIndeferimento?: number
    
    public cancelamentoAtivo?: boolean
    public inicioAmareloCancelamento?: number
    public finalAmareloCancelamento?: number
    
    public certificadoAtivo?: boolean
    public corCertificadoRegular?: string
    public corCertificadoIrregular?: string
    
    public autosAtivo?: boolean
    public corPossuiAutos?: string
    public corNaoPossuiAutos?: string
    
    public embargosAtivo?: boolean
    public corPossuiEmbargos?: string
    public corNaoPossuiEmbargos?: string

    public tempoCadastradoCtfAtivo?: boolean
    public inicioAmareloTempoCadastrado?: number
    public finalAmareloTempoCadastrado?: number

    public classificacaoModeloAtivo?: boolean
    public modelosIndicador?: ModeloIndicador[];

}